import React, {useEffect, useState} from 'react'
import {Link, useHistory, useParams} from "react-router-dom"
import {useForm} from "react-hook-form"
import InputMask from 'react-input-mask'
import {useAlert} from 'react-alert'
import countriesList from '../../assets/countries';

import useApi from "../../useApi";
import {getRecurlySubscription, getSubscriptionPrice, postRecurlySubscription} from "../../api"
import Logo from "../../assets/images/logo@2x.png"
import Footer from "../../components/Footer/Footer"
import MobileFooter from "../../components/Footer/MobileFooter"
import {useQuery} from "../../useQuery"
import * as yup from "yup";

countriesList.unshift(['', null]);

const validationSchema = yup.object().shape({
    cardholderName: yup.string().required(),
    cardNumber: yup.string().test(('cardNumber completion', '', val => {
        return !val.includes('_');
    })).required(),
    expiryDate: yup.string().test(('expiryDate completion', '', val => {
        return !val.includes('_');
    })).required(),
    cvv: yup.string().test(('cvv completion', '', val => {
        return !val.includes('_');
    })).required(),
    country: yup.string().test(('country completion', '', val => {
        return !val.includes('_');
    })).required(),
    street1: yup.string().test(('street1 completion', '', val => {
        return !val.includes('_') && val.length >= 2;
    })).required(),
    city: yup.string().test(('city completion', '', val => {
        return !val.includes('_');
    })).required(),
    postalCode: yup.string().test(('postalCode completion', '', val => {
        return !val.includes('_');
    })).required(),
});

export default function PaymentDetailsForm() {
    const history = useHistory();
    const {id} = useParams();
    const {register, handleSubmit, errors} = useForm({validationSchema});
    const alert = useAlert();
    const [{data}, get] = useApi({alert});
    const [{data: result, error}, post] = useApi({defaultErrorMessage: "There has been an issue processing your payment."});
    const [{data: priceData}, getPrice] = useApi({alert});
    const [ccNumberMask, setCcNumberMask] = useState("9999-9999-9999-9999");
    const [ccCvvMask, setCcCvvMask] = useState("999");
    const query = useQuery();
    const annual = query.get("annual");

    useEffect(() => {
        if (id) get(getRecurlySubscription(id))
    }, [id, get]);

    useEffect(() => {
        if (result && result.subscribed)
            history.push('/apply/membership/premium/thank-you');
    }, [result]);

    useEffect(() => {
        if (id)
            getPrice(getSubscriptionPrice(id))
    }, [id, getPrice]);

    const onSubmit = data => {
        data.id = id;
        data.isAnnual = annual == "true";
        post(postRecurlySubscription(data))
    };

    const getFieldClassName = (err) => {
        return `field${err ? " field--error" : ""}`;
    };

    const onCcNumberChange = (number) => {
        // AMEX
        if (number.match(new RegExp('^3[47]')) != null) {
            setCcNumberMask('9999-999999-99999');
            setCcCvvMask('9999');
            return;
        }

        // Diners International
        if (number.match(new RegExp('^3(?:0[0-5]|[68][0-9])[0-9]{11}$')) != null) {
            setCcNumberMask('9999-999999-9999');
            return
        }

        setCcNumberMask('9999-9999-9999-9999');
        setCcCvvMask('999');
    };

    return (
        <section className="section-form">
            <div className="section__outer">

                <div className="section__aside">
                    <div className="section__inner">
                        <div className="section__inner-content">
                            <Link to="/" className="logo">
                                <img src={Logo} alt="" width="200" height="20"/>
                            </Link>

                            <div className="section__head section__head--centered">
                                <p>{annual ? "Annual" : "Monthly"} Premium Membership</p>

                                <h1 className="section__title">${annual ? priceData.annualPrice : priceData.monthlyPrice}</h1>
                            </div>
                        </div>
                    </div>
                    <Footer/>
                </div>


                <div className="section__content">

                    {error ? (
                        <div className="bar section__bar">
                            <div className="bar__content">
                                <p>
                                    {error}
                                    <br/>
                                    Please reach out membership@theroom.com to discuss further.
                                </p>
                            </div>
                        </div>
                    ) : null}

                    <div className="section__content-inner">
                        <div className="form-payment">
                            <div className="form__inner">
                                <h2 className="form__title">Enter Payment Information</h2>

                                <div className="form__body">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form__row">
                                            <label htmlFor="cardholderName" className="form__label">Cardholder
                                                Name</label>
                                            <div className="form__controls">
                                                <input type="text"
                                                       className={getFieldClassName(errors.cardholderName)}
                                                       id="cardholderName" name='cardholderName'
                                                       ref={register}
                                                       defaultValue={data.cardholderName}
                                                />
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="cardNumber" className="form__label">Card Number</label>
                                            <div className="form__controls">
                                                <InputMask className={getFieldClassName(errors.cardNumber)}
                                                           id="cardNumber"
                                                           name='cardNumber'
                                                           inputRef={register}
                                                           mask={ccNumberMask}
                                                           defaultValue={data.cardNumber}
                                                           onChange={(e) => onCcNumberChange(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="form__row form__row--small">
                                            <div className="form__group form__group--md">
                                                <label htmlFor="expiryDate" className="form__label">Expiry Date</label>
                                                <div className="form__controls">
                                                    <InputMask className={getFieldClassName(errors.expiryDate)}
                                                               id="expiryDate"
                                                               name='expiryDate'
                                                               mask="99/9999" maskPlaceholder={null}
                                                               inputRef={register}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form__group form__group--small">
                                                <label htmlFor="cvv" className="form__label">CVC</label>
                                                <div className="form__controls">
                                                    <InputMask className={getFieldClassName(errors.cvv)}
                                                               id="cvv"
                                                               name='cvv' inputRef={register}
                                                               mask={ccCvvMask} maskPlaceholder={null}
                                                               defaultValue={data.cvv}/>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__row form__row--large">
                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="country" className="form__label">
                                                    Country
                                                </label>
                                                <div className="form__controls">
                                                    <select
                                                       className={getFieldClassName(errors.country)}
                                                       id='country'
                                                       name='country'
                                                       ref={register}
                                                       defaultValue={data.country}
                                                    >
                                                        {
                                                            countriesList.map(([name, value]) => (
                                                                <option key={value} value={value}>{name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="city" className="form__label">
                                                    City
                                                </label>
                                                <div className="form__controls">
                                                    <input type="text"
                                                           className={getFieldClassName(errors.city)}
                                                           id="city"
                                                           name='city'
                                                           ref={register}
                                                           defaultValue={data.city}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__row form__row--large">
                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="street1" className="form__label">
                                                    Street Address 1
                                                </label>
                                                <div className="form__controls">
                                                    <input type="text"
                                                           className={getFieldClassName(errors.street1)}
                                                           id="street1"
                                                           name='street1'
                                                           ref={register}
                                                           defaultValue={data.street1}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="street2" className="form__label">
                                                    Street Address 2 (optional)
                                                </label>
                                                <div className="form__controls">
                                                    <input type="text"
                                                           className={getFieldClassName(errors.street2)}
                                                           id="street2"
                                                           name='street2'
                                                           ref={register}
                                                           defaultValue={data.street2}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__row form__row--large">
                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="postalCode" className="form__label">
                                                    Zip/Postal Code
                                                </label>
                                                <div className="form__controls">
                                                    <input type="text"
                                                           className={getFieldClassName(errors.postalCode)}
                                                           id="postalCode"
                                                           name='postalCode'
                                                           ref={register}
                                                           defaultValue={data.postalCode}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form__group form__group--md form__group--mobile-lg">
                                                <label htmlFor="region" className="form__label">
                                                    State/Province (optional)
                                                </label>
                                                <div className="form__controls">
                                                    <input type="text"
                                                           className={getFieldClassName(errors.region)}
                                                           id="region"
                                                           name='region'
                                                           ref={register}
                                                           defaultValue={data.region}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__row ">
                                            <div className="tag tag-brown tag-brown-no-box">
                                                Billing address should match with the one on file at your card-issuing bank
                                            </div>
                                        </div>

                                        <div className="form__actions">
                                            <button type="submit" className="btn__form">Pay now</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="section__actions section__actions--bottom">
                                <Link className="section__link"
                                      to={"/apply/membership/" + id}>
                                    &lt;&nbsp;Back to Subscription Plan
                                </Link>
                            </div>
                        </div>

                        <MobileFooter/>

                    </div>
                </div>
            </div>
        </section>
    )
}
